///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalContest {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import ILocationService = angular.ILocationService;
    import TabService = TotalCore.Common.Providers.TabService;

    @Controller('controllers.totalcontest')
    export class EditorCtrl {
        public information = this.SettingsService.information;
        public modules = this.SettingsService.modules;
        public settings = this.SettingsService.settings;
        public presets = this.SettingsService.presets;
        public text = 'Hello';


        constructor(private $rootScope, private SettingsService: SettingsService, private $location: ILocationService, private TabService: TabService) {
            let urlParams = this.$location.search();
            $rootScope.settings = this.settings;
            $rootScope.information = this.information;
            $rootScope.modules = this.modules;

            $rootScope.$applyAsync(() => {
                if (!urlParams.tab) {
                    TabService.set('editor', 'form');
                }
            });
        }

        hasRequiredCategoryField() {
            for (let field of this.$rootScope.settings.contest.form.fields) {
                if (field.type === 'category' && field.validations.filled.enabled) {
                    return true;
                }
            }
            return false;
        }

        setTimeout(target, timeout) {
            this.$rootScope.settings[target].frequency.timeout = parseInt(timeout, 10);
        }

        isCustomTimeout(target) {
            return ! (this.$rootScope.settings[target].frequency.timeout in this.presets.timeout);
        }

        getFormFieldsByType(type) {
            return this.settings.contest.form.fields.filter((field) => {

                switch (type) {
                    case 'email' :
                        return field.validations.email && field.validations.email.enabled;
                    default: {
                        return field.type === type;
                    }
                }
            });
        }
    }

}
